import { FC, useEffect, useState } from 'react'
import styled from 'styled-components'
import { zIndex } from 'shared/lib'
import Button from 'shared/components/Button'
import Modal from 'shared/components/Modal'
import { SVGIcon } from 'shared/components/Icons'
import { ProductQA } from 'shared/dataAttributes'
import getConfig from 'next/config'
import { sizes } from 'shared/lib/media'
import { useMediaQuery } from 'react-responsive'

interface IKlarnaPromotional {
  price?: number
}

export const KlarnaPromotional: FC<IKlarnaPromotional> = props => {
  const { publicRuntimeConfig } = getConfig()
  const klarnaClientId = publicRuntimeConfig.klarnaClientId
  const klarnaOsmUrl = publicRuntimeConfig.klarnaOsmUrl

  const urlParams = new URLSearchParams({
    client_id: klarnaClientId,
    placement_key: 'credit-promotion-badge',
    locale: 'en-US',
    channel: 'web',
    purchase_amount: props?.price.toString(),
  })

  const [promoText, setPromoText] = useState('')
  const [learnMoreText, setLearnMoreText] = useState('')
  const [learnMoreUrl, setLearnMoreUrl] = useState('')

  const isMobile = useMediaQuery({ maxWidth: sizes.small })

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await fetch(`${klarnaOsmUrl}messaging?${urlParams}`)
        const data = await response.json()
        setPromoText(data?.content?.nodes[0]?.value)
        setLearnMoreText(data?.content?.nodes[1]?.label)
        setLearnMoreUrl(data?.content?.nodes[1]?.url)
      } catch (error) {
        // TODO: Catch this error properly this is failing tests
        // bugsnagClient.notify(error)
      }
    }
    getData()
  }, [])

  const [isKlarnaModalOpen, setIsKlarnaModalOpen] = useState(false)
  const handleCloseKlarnaModal = () => {
    setIsKlarnaModalOpen(false)
  }
  const handleLearnMoreClick = () => {
    setIsKlarnaModalOpen(true)
  }
  return (
    <>
      <div>
        {promoText}&nbsp;
        <Button buttonType="link" onClick={handleLearnMoreClick}>
          {learnMoreText}
        </Button>
      </div>

      <Modal
        data-testid="klarna-modal"
        widthOverride="auto"
        isOpen={isKlarnaModalOpen}
        onClose={handleCloseKlarnaModal}
      >
        <ContentWrapper>
          <XIconWrapper
            data-qa={ProductQA.KlarnaPromotionCloseIcon}
            data-testid="klarna-modal-x"
            onClick={handleCloseKlarnaModal}
          >
            <XIcon />
          </XIconWrapper>
          <iframe
            width="550"
            height={isMobile ? '850' : '760'}
            style={{ border: 'none' }}
            src={learnMoreUrl}
          />
        </ContentWrapper>
      </Modal>
    </>
  )
}

const ContentWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  overflow-y: auto;
`
const XIcon = styled(SVGIcon).attrs({
  size: 'small',
  name: 'closeX',
})``

const XIconWrapper = styled.div`
  z-index: ${zIndex.justOverNav};
  position: absolute;
  cursor: pointer;
  padding: 20px;
  right: 0;
`
